import { render, staticRenderFns } from "./BaseRefreshView.vue?vue&type=template&id=97fa128c"
import script from "./BaseRefreshView.vue?vue&type=script&lang=js"
export * from "./BaseRefreshView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports